import { combineReducers } from 'redux';
import { SET_UPCOMING_EVENTS } from '../../actions/events';

const ids = (state = [], { type, payload }) => {
    let newState = state;

    if (type === SET_UPCOMING_EVENTS) {
        newState = [...newState, ...payload.ids];
    }

    return newState;
};

const continuation = (state = '', { type, payload }) => {
    let newState = state;

    if (type === SET_UPCOMING_EVENTS) {
        newState = payload.continuation;
    }

    return newState;
};

export default combineReducers({
    ids,
    continuation,
    totalItems: (state = '') => state,
});
